import { CoolHttpModule } from '@angular-cool/http';
import { CoolStorageModule } from '@angular-cool/storage';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxsModule } from '@ngxs/store';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { AppState } from './app.state';
import { HelpSiteService } from './common/services/help-site.service';
import { ENVIRONMENT, WINDOW } from './common/services/injection-tokens';
import { GlobalErrorHandler } from './common/services/logger/global-error-handler';
import { LoggerService } from './common/services/logger/logger.service';
import { RouteNavigationService } from './common/services/route-navigation.service';
import { StartupService } from './common/services/startup.service';
import { NavState } from './core/navigation/navigation.state';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: WINDOW, useValue: window },
    { provide: ErrorHandler, useClass: environment.logging?.enabled ? GlobalErrorHandler : ErrorHandler },

    provideZonelessChangeDetection(),

    provideAppInitializer(() => inject(StartupService).setupAsync()),

    provideRouter(routes),
    provideAnimationsAsync(),

    importProvidersFrom(
      NgxsModule.forRoot([AppState], {
        developmentMode: !environment.production,
      }),
      NgxsSelectSnapshotModule.forRoot(),

      CoolHttpModule.forRoot(),
      CoolStorageModule.forRoot(),
    ),

    LoggerService,
    StartupService,

    RouteNavigationService,

    NavState,

    HelpSiteService,
  ],
};
